import { alpha } from "@mui/material/styles";
import { common } from "@mui/material/colors";
import type { PaletteOptions } from "@mui/material/styles/createPalette";

import type { ColorPreset, Contrast } from "..";
import {
  brandGradient,
  chart,
  disabledText,
  error,
  formField,
  headingText,
  info,
  mobile,
  neutral,
  notification,
  placeholderText,
  premiumGold,
  signer,
  splitButton,
  subText,
  success,
  switchControl,
  table,
  warning,
} from "../colors";
import { getPrimary } from "../utils";

interface Config {
  colorPreset?: ColorPreset;
  contrast?: Contrast;
}

export const createPalette = (config: Config): PaletteOptions => {
  const { colorPreset, contrast } = config;

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12),
    },
    background: {
      default: contrast === "high" ? neutral[50] : common.white,
      paper: common.white,
    },
    divider: "rgba(71, 85, 105, 0.25)",
    error,
    info,
    mode: "light",
    brandGradient,
    chart,
    formField,
    mobile,
    signer,
    neutral,
    notification,
    premium: premiumGold,
    primary: getPrimary(colorPreset),
    splitButton,
    success,
    switchControl,
    table,
    text: {
      primary: headingText,
      secondary: subText,
      disabled: disabledText,
      placeholder: placeholderText,
    },
    warning,
  };
};
